import { CollectionCallsTable } from './CollectionCallsTable'

export default function CollectionCalls({ isLoan = true }: { isLoan?: boolean }) {
  return (
    <div className="collection-calls-container">
      <div className="max-w-screen-2xl m-auto">
        <CollectionCallsTable isLoan={isLoan} />
      </div>
    </div>
  )
}
